import { APP_HIDE_LOADING, APP_SHOW_LOADING } from './actionTypes'

export const showLoading = count => ({
  type: APP_SHOW_LOADING,
  meta: {},
  payload: {
    count
  }
})

export const hideLoading = () => ({
  type: APP_HIDE_LOADING,
  meta: {},
  payload: {}
})

export default {
  showLoading,
  hideLoading
}
